import '../scss/main.scss';

import Tabs from './tabs';

window.addEventListener('DOMContentLoaded', function() {
	let priceListContainers = document.querySelectorAll('.price-list-container');

	if (priceListContainers.length < 1) {
		return;
	}

	priceListContainers = [].slice.call(priceListContainers);

	priceListContainers.forEach( container => {
		const navContainer = container.querySelector('.price-list-nav-container');
		const contentContainer = container.querySelector('.price-list-real-estate-objects-container');

		if (navContainer && contentContainer) {
			new Tabs(
				navContainer,
				contentContainer,
				{
					disableLinks: true
				}
			);
		}
	});
});